import { AxiosErrorResponse } from '@/@types/Errors';
import { AxiosError } from 'axios';
import { TFunction } from 'i18next';

const RECURRING_ERROR_KEYS = new Set([
  'recurring_offer_not_enabled',
  'recurring_payment_method_unavailable',
  'recurring_payment_method_not_supported',
  'recurring_payment_methods_required',
  'recurring_plan_create_failed',
  'recurring_plan_update_failed',
  'recurring_plan_activate_failed',
  'recurring_plan_deactivate_failed',
  'recurring_plan_sync_disabled',
]);

export function translateApiError(message: string | undefined, t: TFunction): string {
  if (!message) {
    return '';
  }

  if (RECURRING_ERROR_KEYS.has(message)) {
    return t(`common:${message}`);
  }

  return message;
}

export function getApiErrorMessage(
  error: AxiosError<AxiosErrorResponse> | undefined,
  t: TFunction,
): string {
  const validationErrors = error?.response?.data?.errors;

  if (validationErrors) {
    const firstMessage = Object.values(validationErrors).flat()[0];

    if (typeof firstMessage === 'string') {
      return translateApiError(firstMessage, t);
    }
  }

  return (
    translateApiError(error?.response?.data?.message, t) ||
    t('common:data_submission_error')
  );
}
